import React, { useEffect, useRef } from "react";
import { animate } from "animejs";

export default function CountUp({
  to,
  suffix = "",
  prefix = "",
  duration = 1400,
  className = "",
  decimals = 0,
}) {
  const ref = useRef(null);
  const end = Number(to) || 0;

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      el.textContent = `${prefix}${end.toFixed(decimals)}${suffix}`;
      return undefined;
    }

    const obj = { v: 0 };
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        animate(obj, {
          v: end,
          duration,
          ease: "out(3)",
          onUpdate: () => {
            const value = decimals > 0 ? obj.v.toFixed(decimals) : String(Math.round(obj.v));
            el.textContent = `${prefix}${value}${suffix}`;
          },
        });
        io.unobserve(el);
      },
      { threshold: 0.4 }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [end, suffix, prefix, duration, decimals]);

  return (
    <span ref={ref} className={className} aria-label={`${prefix}${end}${suffix}`}>
      {prefix}0{suffix}
    </span>
  );
}
